import { render, staticRenderFns } from "./df-page-shopping-list.vue?vue&type=template&id=717e004f&"
import script from "./df-page-shopping-list.ts?vue&type=script&lang=js&"
export * from "./df-page-shopping-list.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports